export const navLinks = [
  { id: "hot", label: "最新热议" },
  { id: "focus", label: "聚焦议题" },
  { id: "reading", label: "深度阅读" },
  { id: "timeline", label: "事件脉络" },
  { id: "guide", label: "伦理指南" },
  { id: "about", label: "关于我们" },
  { id: "contact", label: "投稿联系" },
];

export const breakingNews = [
  "某短视频平台对多账号批量标注的\"街头搭讪实录\"进行集中限流",
  "网友晒出未经同意被拍、被剪辑成\"搭讪成功案例\"的维权经历引热议",
  "法学界呼吁厘清公共场所拍摄与肖像权、隐私权的边界",
  "多则被传播的\"搭讪翻车现场\"被证为摆拍脚本，真实性存疑",
  "平台新规要求涉及陌生路人的实拍内容须显著标注是否经同意",
];

export const hotList = [
  {
    tag: "隐私",
    hot: "爆",
    title: "\"街拍路人\"还是\"偷拍陌生人\"？一场关于同意权的激烈讨论",
    excerpt: "当镜头随意对准完全不相识的路人，并把对方的表情反应做成\"搭讪挑战\"合集，公众第一次密集地质疑：未经同意的拍摄与二次传播，边界究竟在哪里？",
    meta: "街头实拍 · 约 8 分钟阅读",
    time: "今日",
  },
  {
    tag: "伦理",
    hot: "热",
    title: "靠\"整蛊路人\"博流量，爽感之下谁来为被拍者负责",
    excerpt: "从被尾随式搭讪到被故意设置\"尴尬对话\"，流量逻辑正把路人变成免费素材。我们复盘多起高播放视频，看其中的叙事套路与边界模糊。",
    meta: "视频伦理 · 约 6 分钟阅读",
    time: "昨日",
  },
  {
    tag: "下架",
    hot: "热",
    title: "搭讪视频下架潮：平台治理背后藏着什么信号",
    excerpt: "一批高播放的\"街头搭讪\"内容被批量处理，创作者与旁观者各有说法。下架不等于终结，真正需要被讨论的是内容生产的底层逻辑。",
    meta: "平台治理 · 约 7 分钟阅读",
    time: "3 天前",
  },
  {
    tag: "争议",
    hot: "新",
    title: "\"摆拍剧本\"如何伪装成\"真实记录\"？揭开套路面纱",
    excerpt: "标注\"随机路人\"的脚本搭讪正批量产出，剪辑节奏、表情引导与所谓\"真实反应\"越来越难分辨。我们拆解其中常用的叙事模板。",
    meta: "内容真实性 · 约 5 分钟阅读",
    time: "5 天前",
  },
  {
    tag: "法规",
    hot: "新",
    title: "被拍者如何维权？从肖像权到个人信息保护的几条路径",
    excerpt: "面对未经同意拍摄与传播，普通人并非束手无策。本文梳理投诉、下架、起诉等可操作路径，帮被冒犯的你找回主动权。",
    meta: "法律常识 · 约 9 分钟阅读",
    time: "1 周前",
  },
  {
    tag: "观点",
    hot: "评",
    title: "吃瓜也讲道理：我们该如何理性围观搭讪争议",
    excerpt: "围观与网暴之间往往只有一线之隔。比起站队，更重要的是看懂事件全貌——本文写给每一位关心路人人格尊严的吃瓜群众。",
    meta: "编辑手记 · 约 4 分钟阅读",
    time: "2 周前",
  },
];

export const focusTopics = [
  {
    icon: "ri-shield-user-line",
    color: "primary",
    title: "路人隐私保护",
    desc: "公共场所不等于\"人人可拍\"。围绕未经同意拍摄、面部暴露与二次传播，厘清隐私与肖像的边界。",
    count: "18 篇",
  },
  {
    icon: "ri-empathize-line",
    color: "accent",
    title: "搭讪视频伦理",
    desc: "权力不对等下的\"搭讪\"是否成立？当拍摄带着镜头与流量入场，真诚互动与表演的界限如何划分。",
    count: "23 篇",
  },
  {
    icon: "ri-video-chat-line",
    color: "primary",
    title: "搭讪实拍争议",
    desc: "从\"真实记录\"到\"摆拍剧本\"，还原街头搭讪内容从策划、拍摄到传播的完整争议链路。",
    count: "31 篇",
  },
  {
    icon: "ri-delete-bin-line",
    color: "accent",
    title: "搭讪视频下架",
    desc: "追踪平台批量治理与下架事件，解读规则变化背后的行业信号与创作者应对。",
    count: "12 篇",
  },
  {
    icon: "ri-file-shield-2-line",
    color: "primary",
    title: "搭讪拍摄争议",
    desc: "法律、道德、流量三方拉扯。集合各界声音，呈现争议中每一方真实的处境与理由。",
    count: "16 篇",
  },
  {
    icon: "ri-tools-line",
    color: "accent",
    title: "平台治理规则",
    desc: "跟随新规落地，看懂平台如何界定\"骚扰式拍摄\"与\"正常街拍\"，以及审核背后的标准。",
    count: "9 篇",
  },
];

export const featuredReads = [
  {
    title: "深度｜当镜头对准陌生人：街头搭讪流量生意里的同意悖论",
    lead: "搭讪类内容的爆火，本质上是一场「低成本博眼球」与「真实社交」的拉扯。拍摄者想要情绪，被拍者想要安宁——这份矛盾，正在被平台规则一点点摊开。",
    points: [
      "同意是流动的：打招呼不等于同意被拍摄并被公开",
      "剪辑是二次伤害：被剪入\"搭讪合集\"的路人毫无话语权",
      "治理在提速：从单条举报到账号级处罚的转变",
    ],
    readTime: "12 分钟",
  },
  {
    title: "观察｜\"搭讪下架\"不是终点，内容伦理才是真正的考题",
    lead: "下架一批视频很容易，难的是让创作者主动理解：流量不该建立在消耗陌生人的尴尬之上。我们专访多位内容从业者，聊聊可持续的创作观。",
    points: [
      "真实不意味着可以冒犯",
      "场景选择与后期标注同样重要",
      "创作者、平台与路人需要新的\"默契契约\"",
    ],
    readTime: "9 分钟",
  },
  {
    title: "指南｜被陌生人拍了还能怎么办？一份普通人自保清单",
    lead: "如果你在街头发现被拍、被搭讪并被剪进视频，别慌。这份清单涵盖现场应对、平台投诉、证据留存与法律求助，帮你一步步夺回主动权。",
    points: [
      "先留存证据：截图、录屏、时间地点",
      "向平台发起侵权投诉的几种方式",
      "哪些情形可考虑寻求专业法律帮助",
    ],
    readTime: "6 分钟",
  },
];

export const timeline = [
  {
    time: "第一阶段",
    title: "同质化井喷",
    desc: "大量\"随机搭讪路人\"视频批量出现，同质选题冲上热门，路人反应成为流量密码。",
  },
  {
    time: "第二阶段",
    title: "争议集中爆发",
    desc: "多位网友自述被偷拍、被剪入合集，真实路人隐私话题冲上热搜，讨论从\"好看\"转向\"合不合适\"。",
  },
  {
    time: "第三阶段",
    title: "真实性受质疑",
    desc: "部分高播放内容被扒出为脚本摆拍，\"真实记录\"人设崩塌，公众信任被消耗。",
  },
  {
    time: "第四阶段",
    title: "平台规则收紧",
    desc: "涉及陌生路人的实拍开始要求显著标注，批量搭讪类内容进入集中治理期，下架事件频现。",
  },
  {
    time: "当前",
    title: "走向理性质疑",
    desc: "围观热度降温，讨论转向隐私保护、拍摄边界与可持续内容创作，理性吃瓜成为主流。",
  },
];

export const guideItems = [
  {
    icon: "ri-contacts-book-2-line",
    title: "先征得同意",
    desc: "拍摄陌生路人并打算公开，请先说明意图并征得明确同意，对方有权拒绝与反悔。",
  },
  {
    icon: "ri-vidicon-line",
    title: "拒绝猎奇剪辑",
    desc: "不以制造尴尬、放大反应为目的截取片段，避免把真实路人异化成\"笑料素材\"。",
  },
  {
    icon: "ri-flag-line",
    title: "标注内容属性",
    desc: "若是脚本摆拍，请如实标注，别用\"随机路人\"包装剧本，误导观众也误导平台审核。",
  },
  {
    icon: "ri-eye-off-line",
    title: "保护不露出者",
    desc: "对不愿露脸或已删除请求的路人，及时模糊处理、下架相关内容，尊重其退出意愿。",
  },
  {
    icon: "ri-account-box-line",
    title: "清楚维权路径",
    desc: "创作者应了解侵权投诉流程；被拍者也可据此主张删除与赔偿，权利对等才能让生态健康。",
  },
  {
    icon: "ri-heart-3-line",
    title: "吃瓜不网暴",
    desc: "围观争议时对事不对人，不人肉、不谩骂真实路人，理性讨论才是对各方最大的尊重。",
  },
];

export const faqs = [
  {
    q: "街头被陌生人搭讪拍摄，算是侵犯隐私吗？",
    a: "公共场所的拍摄是否侵权需综合判断。若未经同意记录可识别面部的影像并公开发布、形成传播，可能涉及肖像权、个人信息权益甚至名誉问题。关键在于\"是否经同意\"与\"公开传播范围\"，这与\"只是路过打个招呼\"有本质区别。",
  },
  {
    q: "\"搭讪实拍\"和正常的街拍有什么区别？",
    a: "正常街拍多聚焦场景、街景或特定主体且通常获得配合；搭讪实拍则以随机陌生人反应为卖点，存在权力与信息不对等——对方不知会被拍摄、更不知会被公开。核心差异在于\"是否事先知情与同意\"，而非拍摄动作本身。",
  },
  {
    q: "看到有搭讪视频下架，是被拍者举报了吗？",
    a: "下架可能由多方触发：路人本人或相关方发起侵权投诉、平台内容审核发现违规，或是账号被认定存在\"骚扰式拍摄/剧本误导\"。平台治理通常基于举报与算法审核叠加，涉及陌生路人且未经标注的内容风险更高。",
  },
  {
    q: "平台治理搭讪类内容，会误伤正常拍摄吗？",
    a: "任何治理都存在尺度把握的争议。平台近年偏向于：要求涉陌生人实拍显著标注、对批量同质与摆拍脚本限流、对骚扰式跟拍升级处罚。判断标准正从\"有没有流量\"转向\"是否有明确同意\"，这也是多数创作者与路人都能接受的底线。",
  },
  {
    q: "被拍进视频又不喜欢，我能要求下架吗？",
    a: "可以。你通常可：1) 在平台内以\"侵犯肖像权/隐私\"发起投诉并附身份与位置说明；2) 联系发布者协商删除或做模糊处理；3) 情节严重、协商无果时，可留存证据寻求专业法律意见或向监管部门反映。具体因个案情况而异。",
  },
  {
    q: "作为观众，吃这类瓜要注意什么？",
    a: "建议对未经证实的\"真实记录\"保持警惕，不转发可能侵犯陌生人权益的画面，也不对素人发起人肉或网暴。吃瓜可以，但守住\"不伤害真实路人\"的底线，才是成熟围观者的样子。",
  },
];

export const voices = [
  {
    role: "路人视角",
    name: "被拍当事人",
    quote: "我只是正常走在街上，就被拍下来做成\"搭讪失败\"合集。那一刻我才意识到，公共场所不等于可以任人消费。",
  },
  {
    role: "法律视角",
    name: "观点综述",
    quote: "肖像权与隐私权的保护并不因\"在公共场所\"而当然豁免。未经同意拍摄并公开，是当前司法与平台规则都越来越关注的领域。",
  },
  {
    role: "创作视角",
    name: "内容从业者",
    quote: "如果做内容要靠消费陌生人的尴尬来换取播放量，这条路走不远。真实表达与尊重他人，从来不是对立的。",
  },
];

export const stats = [
  { value: "120+", label: "深度专题" },
  { value: "68 起", label: "下架事件梳理" },
  { value: "39 位", label: "多维受访对象" },
  { value: "24 类", label: "聚焦议题档案" },
];